import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IYearMonth } from '@/coreDomainsModule/date';
import { ForecastForReceiptHeaderKey, TableContentProperty } from '../../interface/tableContentHeaders';
import { TableContentItem } from '../../interface/tableContentItems';
import TableCell from '../TableCell.vue';
import { computed } from 'vue';
import { COLUMN_NAME_FORECAST_DIFF, DiffAmountType, ForecastDiffColumnTypes } from './domains/entities/forecastDiffLastMonth';
import { ForecastDiffLastMonthTableContentViewModel } from './forecastDiffLastMonthTableContentViewModel';
import { ForecastDiffLastMonthService } from './domains/services/forecastDIffLastMonthService';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'ForecastDiffLastMonthTableCell',
  props: {
    header: {},
    headerKey: {},
    item: {},
    headerIndex: {},
    accumulationTableContentWidth: {},
    isVariableWidth: { type: Boolean },
    isAllSelected: { type: Boolean },
    stableColumnCount: {},
    isBold: { type: Boolean },
    forecastStartYearMonth: { default: undefined },
    isChecked: { type: Boolean },
    isCheckedBusinessId: { type: Boolean }
  },
  emits: ["onClickNarrow"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

const forecastDiffLastMonthTableCellVM = new ForecastDiffLastMonthTableContentViewModel();

const textAlign = computed(() => {
  if (props.header.key === 'SupplierForecastCreateStatus') {
    return 'center';
  }
  return props.header.propertyPath?.propertyType === 'number' ? 'right' : 'left';
});

const columnType = computed(() => {
  return ForecastDiffLastMonthService.getColumnType(props.header.key);
});

/**
 * セルのクラスを返す
 * @param columnType - 列の種類
 * @param diffAmountStatus - 差分の種類
 */
const cellItemClasses = (columnType: ForecastDiffColumnTypes, diffAmountStatus: DiffAmountType) => {
  return [
    props.isBold ? 'table-cell-content--bold' : '',
    columnType === 'diffAmount' ? 'table-cell-content__diff-amount' + ` table-cell-content__diff-amount--${diffAmountStatus}` : '',
  ];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableCell, {
    class: _normalizeClass([[_unref(forecastDiffLastMonthTableCellVM).isSticky(_ctx.stableColumnCount, _ctx.headerIndex) ? 'sticky-content' : ''], "table-cell base-table__body--fixed"]),
    style: _normalizeStyle({
      left: _unref(forecastDiffLastMonthTableCellVM).calcStickyDiff(_ctx.stableColumnCount, _ctx.headerIndex, _ctx.accumulationTableContentWidth),
    }),
    "text-align": textAlign.value,
    "table-content-property": _ctx.header,
    "tool-tip-value": _unref(forecastDiffLastMonthTableCellVM).getDisplayForecastDiffItem(_ctx.headerKey, columnType.value, _ctx.item, _ctx.forecastStartYearMonth),
    "is-highlighted": props.isChecked || props.isCheckedBusinessId
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(["table-cell-content", cellItemClasses(columnType.value, _unref(forecastDiffLastMonthTableCellVM).getDiffAmountStatus(_ctx.headerKey, _ctx.item, _ctx.forecastStartYearMonth))]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClickNarrow')))
      }, _toDisplayString(_unref(forecastDiffLastMonthTableCellVM).getDisplayForecastDiffItem(_ctx.headerKey, columnType.value, _ctx.item, _ctx.forecastStartYearMonth)), 3)
    ], undefined, true),
    _: 1
  }, 8, ["class", "style", "text-align", "table-content-property", "tool-tip-value", "is-highlighted"]))
}
}

})